import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/Login.css";
import {
  fetchPermissionsGrantedToUser,
  login,
} from "../services/axios/apiManager";
import {
  handleErrors,
  setUserData,
  setUserToken,
} from "../services/dataManager";
import { useAppContext } from "../services/context";
import Logo from "../assets/images/logo.png";

const Authentication = ({ navigate }) => {
  const { setState } = useAppContext();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    const res = await login({ email, password });

    if (res?.data?.data && res?.data?.token) {
      await setUserData(res.data.data);
      await setUserToken(res.data.token);
      const { role_id, id } = res.data.data;
      const perms = await fetchPermissionsGrantedToUser(role_id, id);
      if (perms?.data?.data) {
        setState((prev) => ({ ...prev, permissions: perms.data.data }));
      }
      navigate("/dashboard");
    } else {
      handleErrors(res, navigate);
    }
  };

  return (
    <main className="nftg-content-two" style={{ backgroundColor: "#0b0f14" }}>
      <section className="authentication pt-120 pb-120 fade-wrapper">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="authentication__wrapper text-center">
                <img src={Logo} style={{ margin: "0 auto", width: "120px" }} />
                <div className="mb-55">
                  <h2
                    className="title-lg fw-8 stroked-text transform-none title-animation"
                    style={{ color: "white", fontWeight: "700" }}
                  >
                    Welcome to Admin Panel
                  </h2>
                  <p
                    className="text-xl text-alter"
                    style={{ color: "gray", fontWeight: "400" }}
                  >
                    We are glad to see you here
                  </p>
                </div>
                <div className="authentication__inner">
                  <div className="custom-tab">
                    <form onSubmit={handleAdminLogin}>
                      <div className="input-single">
                        <label htmlFor="userEmail">Your Email</label>
                        <div className="ic-group">
                          <input
                            required
                            data-testid="loginEmail"
                            type="email"
                            id="userEmail"
                            placeholder="Enter Email"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {/* <MdOutlineMail /> */}
                        </div>
                      </div>
                      <div className="input-single ">
                        <label htmlFor="userPassword">Password</label>
                        <div className="ic-group pass">
                          <input
                            required
                            data-testid="loginPassword"
                            type="password"
                            id="userPassword"
                            placeholder="Enter Password"
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <svg
                            viewBox="0 0 100 100"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            preserveAspectRatio="none"
                            className="cmn-shape"
                          >
                            <path
                              d="M0 0  L100 0  L100 75 L92 100 L0 100 Z"
                              vectorEffect="non-scaling-stroke"
                            />
                          </svg>
                        </div>
                        <p className=" forget">
                          <Link to="/forgot-password">Forget Password?</Link>
                        </p>
                      </div>
                      <div className="btn-wrapper">
                        <button
                          className="btn--secondary"
                          type="submit"
                          aria-label="login"
                          title="login"
                        >
                          Login
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Authentication;
